export default __webpack_public_path__ + "static/media/image-rules.258b753f.svg";